//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class V1IntegrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    //custom code to format date without localization
    formatDateToLocalISO(date: Date): string {
        const pad = (num: number) => num.toString().padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    /**
     * @return OK
     */
    cancelSite(siteId: string, cancelToken?: CancelToken): Promise<AudioEyeSiteDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/audio-eye/sites/{siteId}";

                    if (siteId === undefined || siteId === null)
                throw new Error("The parameter 'siteId' must be defined.");
                    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelSite(_response);
        });
    }

    protected processCancelSite(response: AxiosResponse): Promise<AudioEyeSiteDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = AudioEyeSiteDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<AudioEyeSiteDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AudioEyeSiteDtoApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getSite(siteId: string, cancelToken?: CancelToken): Promise<AudioEyeSiteDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/audio-eye/sites/{siteId}";

                    if (siteId === undefined || siteId === null)
                throw new Error("The parameter 'siteId' must be defined.");
                    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSite(_response);
        });
    }

    protected processGetSite(response: AxiosResponse): Promise<AudioEyeSiteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = AudioEyeSiteDto.fromJS(resultData200);
            return Promise.resolve<AudioEyeSiteDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AudioEyeSiteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSite(siteId: string, body?: UpdateAudioEyeSiteDto | undefined, cancelToken?: CancelToken): Promise<AudioEyeSiteDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/audio-eye/sites/{siteId}";

                    if (siteId === undefined || siteId === null)
                throw new Error("The parameter 'siteId' must be defined.");
                    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
                            url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSite(_response);
        });
    }

    protected processUpdateSite(response: AxiosResponse): Promise<AudioEyeSiteDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = AudioEyeSiteDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<AudioEyeSiteDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AudioEyeSiteDtoApiResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getSites(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<AudioEyeSiteDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/audio-eye/sites?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSites(_response);
        });
    }

    protected processGetSites(response: AxiosResponse): Promise<AudioEyeSiteDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = AudioEyeSiteDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<AudioEyeSiteDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AudioEyeSiteDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createSite(body?: CreateAudioEyeSiteDto | undefined, cancelToken?: CancelToken): Promise<AudioEyeSiteDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/audio-eye/sites";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSite(_response);
        });
    }

    protected processCreateSite(response: AxiosResponse): Promise<AudioEyeSiteDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = AudioEyeSiteDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<AudioEyeSiteDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AudioEyeSiteDtoApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    hasPremiumAda(dealerId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/integrations/audio-eye/dealers/{dealerId}/has-premium-ada";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasPremiumAda(_response);
        });
    }

    protected processHasPremiumAda(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    reactivateSite(siteId: string, cancelToken?: CancelToken): Promise<AudioEyeSiteDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/audio-eye/sites/{siteId}/reactivate";

                    if (siteId === undefined || siteId === null)
                throw new Error("The parameter 'siteId' must be defined.");
                    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivateSite(_response);
        });
    }

    protected processReactivateSite(response: AxiosResponse): Promise<AudioEyeSiteDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = AudioEyeSiteDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<AudioEyeSiteDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AudioEyeSiteDtoApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getObjectFromCache(body?: GetCMSCacheObject | undefined, cancelToken?: CancelToken): Promise<CMSCacheResponseApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/cmscache";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetObjectFromCache(_response);
        });
    }

    protected processGetObjectFromCache(response: AxiosResponse): Promise<CMSCacheResponseApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CMSCacheResponseApiResponseDto.fromJS(resultData200);
            return Promise.resolve<CMSCacheResponseApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CMSCacheResponseApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getF4SalesEngineSettings( cancelToken?: CancelToken): Promise<F4SalesEngineSettingsDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-one-sales-engine-settings";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetF4SalesEngineSettings(_response);
        });
    }

    protected processGetF4SalesEngineSettings(response: AxiosResponse): Promise<F4SalesEngineSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = F4SalesEngineSettingsDto.fromJS(resultData200);
            return Promise.resolve<F4SalesEngineSettingsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F4SalesEngineSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateF4SalesEngineSettings(body?: UpdateF4SalesEngineSettingsDto | undefined, cancelToken?: CancelToken): Promise<F4SalesEngineSettingsDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-one-sales-engine-settings";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateF4SalesEngineSettings(_response);
        });
    }

    protected processUpdateF4SalesEngineSettings(response: AxiosResponse): Promise<F4SalesEngineSettingsDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = F4SalesEngineSettingsDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<F4SalesEngineSettingsDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F4SalesEngineSettingsDtoApiResponseDto>(null as any);
    }

    /**
     * @param entityType (optional) 
     * @param statusId (optional) 
     * @param operationId (optional) 
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getSyncQueueResults(dealerId: number, entityType?: SyncEntityTypeEnum | null | undefined, statusId?: F4SyncQueueResultStatusEnum | null | undefined, operationId?: SyncOperationEnum | null | undefined, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<F4syncQueueResultDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-one-sync-queue/dealers/{dealerId}/results?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (entityType !== undefined && entityType !== null)
                            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
                            if (statusId !== undefined && statusId !== null)
                            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
                            if (operationId !== undefined && operationId !== null)
                            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSyncQueueResults(_response);
        });
    }

    protected processGetSyncQueueResults(response: AxiosResponse): Promise<F4syncQueueResultDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = F4syncQueueResultDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<F4syncQueueResultDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F4syncQueueResultDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param statusId (optional) 
     * @param operationId (optional) 
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getInventorySyncQueueResults(dealerId: number, statusId?: F4SyncQueueResultStatusEnum | null | undefined, operationId?: SyncOperationEnum | null | undefined, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<F4syncQueueResultDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-one-sync-queue/dealers/{dealerId}/inventory-results?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (statusId !== undefined && statusId !== null)
                            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
                            if (operationId !== undefined && operationId !== null)
                            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInventorySyncQueueResults(_response);
        });
    }

    protected processGetInventorySyncQueueResults(response: AxiosResponse): Promise<F4syncQueueResultDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = F4syncQueueResultDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<F4syncQueueResultDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F4syncQueueResultDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param statusId (optional) 
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getFullSyncResults(dealerId: number, statusId?: F4SyncQueueResultStatusEnum | null | undefined, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<F4syncQueueResultDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-one-sync-queue/dealers/{dealerId}/full-sync-results?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (statusId !== undefined && statusId !== null)
                            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFullSyncResults(_response);
        });
    }

    protected processGetFullSyncResults(response: AxiosResponse): Promise<F4syncQueueResultDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = F4syncQueueResultDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<F4syncQueueResultDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F4syncQueueResultDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getFullSyncDetail(dealerId: number, queueId: number, cancelToken?: CancelToken): Promise<F4fullSyncDetailDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-one-sync-queue/dealers/{dealerId}/full-sync-results/{queueId}/detail";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            if (queueId === undefined || queueId === null)
                throw new Error("The parameter 'queueId' must be defined.");
                    url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFullSyncDetail(_response);
        });
    }

    protected processGetFullSyncDetail(response: AxiosResponse): Promise<F4fullSyncDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = F4fullSyncDetailDto.fromJS(resultData200);
            return Promise.resolve<F4fullSyncDetailDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F4fullSyncDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    queueAllByEntityType(dealerId: number, body?: QueueAllSyncRequestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-one-sync-queue/dealers/{dealerId}/queue-all";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueueAllByEntityType(_response);
        });
    }

    protected processQueueAllByEntityType(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    deleteFrazerPayMerchant(merchantId: number, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-pay/merchants/{merchantId}";

                    if (merchantId === undefined || merchantId === null)
                throw new Error("The parameter 'merchantId' must be defined.");
                    url_ = url_.replace("{merchantId}", encodeURIComponent("" + merchantId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFrazerPayMerchant(_response);
        });
    }

    protected processDeleteFrazerPayMerchant(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getFrazerPayMerchant(merchantId: number, cancelToken?: CancelToken): Promise<FrazerPayMerchantDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-pay/merchants/{merchantId}";

                    if (merchantId === undefined || merchantId === null)
                throw new Error("The parameter 'merchantId' must be defined.");
                    url_ = url_.replace("{merchantId}", encodeURIComponent("" + merchantId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFrazerPayMerchant(_response);
        });
    }

    protected processGetFrazerPayMerchant(response: AxiosResponse): Promise<FrazerPayMerchantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = FrazerPayMerchantDto.fromJS(resultData200);
            return Promise.resolve<FrazerPayMerchantDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FrazerPayMerchantDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param includeDeleted (optional) 
     * @return OK
     */
    getFrazerPayMerchants(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, includeDeleted?: boolean | null | undefined, cancelToken?: CancelToken): Promise<FrazerPayMerchantDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-pay/merchants?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (includeDeleted !== undefined && includeDeleted !== null)
                            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFrazerPayMerchants(_response);
        });
    }

    protected processGetFrazerPayMerchants(response: AxiosResponse): Promise<FrazerPayMerchantDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = FrazerPayMerchantDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<FrazerPayMerchantDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FrazerPayMerchantDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createFrazerPayMerchant(body?: CreateFrazerPayMerchantDto | undefined, cancelToken?: CancelToken): Promise<FrazerPayMerchantApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/frazer-pay/merchants";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFrazerPayMerchant(_response);
        });
    }

    protected processCreateFrazerPayMerchant(response: AxiosResponse): Promise<FrazerPayMerchantApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = FrazerPayMerchantApiResponseDto.fromJS(resultData201);
            return Promise.resolve<FrazerPayMerchantApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data as string;
            let result409: any = null;
            let resultData409  = JSON.parse(_responseText);
            result409 = ApiResponseDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FrazerPayMerchantApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    apiTest( cancelToken?: CancelToken): Promise<TestDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/tests";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiTest(_response);
        });
    }

    protected processApiTest(response: AxiosResponse): Promise<TestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TestDto.fromJS(resultData200);
            return Promise.resolve<TestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestDto>(null as any);
    }

    /**
     * @return OK
     */
    getLast30Jobs( cancelToken?: CancelToken): Promise<JenkinsJobBuildsDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/jenkins/automation-tests/jobs";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLast30Jobs(_response);
        });
    }

    protected processGetLast30Jobs(response: AxiosResponse): Promise<JenkinsJobBuildsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = JenkinsJobBuildsDto.fromJS(resultData200);
            return Promise.resolve<JenkinsJobBuildsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JenkinsJobBuildsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    triggerJenkinsAutomationTests(body?: TriggerJenkinsBuildDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/jenkins/automation-tests";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerJenkinsAutomationTests(_response);
        });
    }

    protected processTriggerJenkinsAutomationTests(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    deleteKnownIssue(issueId: number, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/known-issues/issues/{issueId}";

                    if (issueId === undefined || issueId === null)
                throw new Error("The parameter 'issueId' must be defined.");
                    url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteKnownIssue(_response);
        });
    }

    protected processDeleteKnownIssue(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getKnownIssues(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<KnownIssueDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/known-issues/issues?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKnownIssues(_response);
        });
    }

    protected processGetKnownIssues(response: AxiosResponse): Promise<KnownIssueDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = KnownIssueDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<KnownIssueDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnownIssueDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createKnownIssue(body?: CreateKnownIssueDto | undefined, cancelToken?: CancelToken): Promise<KnownIssueDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/known-issues/issues";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateKnownIssue(_response);
        });
    }

    protected processCreateKnownIssue(response: AxiosResponse): Promise<KnownIssueDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = KnownIssueDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<KnownIssueDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data as string;
            let result409: any = null;
            let resultData409  = JSON.parse(_responseText);
            result409 = ApiResponseDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnownIssueDtoApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    updateKnownIssue(body?: UpdateKnownIssueDto | undefined, cancelToken?: CancelToken): Promise<KnownIssueDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/known-issues/issues";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateKnownIssue(_response);
        });
    }

    protected processUpdateKnownIssue(response: AxiosResponse): Promise<KnownIssueDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = KnownIssueDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<KnownIssueDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data as string;
            let result409: any = null;
            let resultData409  = JSON.parse(_responseText);
            result409 = ApiResponseDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnownIssueDtoApiResponseDto>(null as any);
    }

    /**
     * @param issueId (optional) 
     * @return OK
     */
    getKnownIssue(issueId?: number | undefined, cancelToken?: CancelToken): Promise<KnownIssueDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/known-issues/issue?";

                            if (issueId === null)
                throw new Error("The parameter 'issueId' cannot be null.");
            else if (issueId !== undefined)
                            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKnownIssue(_response);
        });
    }

    protected processGetKnownIssue(response: AxiosResponse): Promise<KnownIssueDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = KnownIssueDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<KnownIssueDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnownIssueDtoApiResponseDto>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param search (optional) 
     * @param dealerId (optional) 
     * @param applicationName (optional) 
     * @param level (optional) 
     * @return OK
     */
    getApplicationLogs(page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, search?: string | undefined, dealerId?: number | null | undefined, applicationName?: string | undefined, level?: ApplicationLogLevelEnum | null | undefined, cancelToken?: CancelToken): Promise<ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/application/logs?";

                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (startDate !== undefined && startDate !== null)
                            url_ += "startDate=" + encodeURIComponent(startDate ? "" + this.formatDateToLocalISO(startDate) : "") + "&";
                            if (endDate !== undefined && endDate !== null)
                            url_ += "endDate=" + encodeURIComponent(endDate ? "" + this.formatDateToLocalISO(endDate) : "") + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (dealerId !== undefined && dealerId !== null)
                            url_ += "DealerId=" + encodeURIComponent("" + dealerId) + "&";
                            if (applicationName === null)
                throw new Error("The parameter 'applicationName' cannot be null.");
            else if (applicationName !== undefined)
                            url_ += "ApplicationName=" + encodeURIComponent("" + applicationName) + "&";
                            if (level !== undefined && level !== null)
                            url_ += "Level=" + encodeURIComponent("" + level) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationLogs(_response);
        });
    }

    protected processGetApplicationLogs(response: AxiosResponse): Promise<ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto.fromJS(resultData200);
            return Promise.resolve<ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto>(null as any);
    }

    /**
     * @return OK
     */
    getApplicationLog(indexName: string, id: string, cancelToken?: CancelToken): Promise<ApplicationLogDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/application/logs/{indexName}/{id}";

                    if (indexName === undefined || indexName === null)
                throw new Error("The parameter 'indexName' must be defined.");
                    url_ = url_.replace("{indexName}", encodeURIComponent("" + indexName));
                            if (id === undefined || id === null)
                throw new Error("The parameter 'id' must be defined.");
                    url_ = url_.replace("{id}", encodeURIComponent("" + id));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationLog(_response);
        });
    }

    protected processGetApplicationLog(response: AxiosResponse): Promise<ApplicationLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApplicationLogDto.fromJS(resultData200);
            return Promise.resolve<ApplicationLogDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationLogDto>(null as any);
    }

    /**
     * @return OK
     */
    getSystemInformationForAllApps( cancelToken?: CancelToken): Promise<SystemInformationDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/system-information";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSystemInformationForAllApps(_response);
        });
    }

    protected processGetSystemInformationForAllApps(response: AxiosResponse): Promise<SystemInformationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = SystemInformationDto.fromJS(resultData200);
            return Promise.resolve<SystemInformationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemInformationDto>(null as any);
    }

    /**
     * @return OK
     */
    closeTwilioAccount(accountSid: string, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/twilio-accounts/{accountSid}";

                    if (accountSid === undefined || accountSid === null)
                throw new Error("The parameter 'accountSid' must be defined.");
                    url_ = url_.replace("{accountSid}", encodeURIComponent("" + accountSid));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseTwilioAccount(_response);
        });
    }

    protected processCloseTwilioAccount(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getTwilioAccount(accountSid: string, cancelToken?: CancelToken): Promise<TwilioAccountDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/twilio-accounts/{accountSid}";

                    if (accountSid === undefined || accountSid === null)
                throw new Error("The parameter 'accountSid' must be defined.");
                    url_ = url_.replace("{accountSid}", encodeURIComponent("" + accountSid));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTwilioAccount(_response);
        });
    }

    protected processGetTwilioAccount(response: AxiosResponse): Promise<TwilioAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TwilioAccountDto.fromJS(resultData200);
            return Promise.resolve<TwilioAccountDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TwilioAccountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTwilioAccount(accountSid: string, body?: UpdateTwilioAccountDto | undefined, cancelToken?: CancelToken): Promise<TwilioAccountDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/twilio-accounts/{accountSid}";

                    if (accountSid === undefined || accountSid === null)
                throw new Error("The parameter 'accountSid' must be defined.");
                    url_ = url_.replace("{accountSid}", encodeURIComponent("" + accountSid));
                            url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTwilioAccount(_response);
        });
    }

    protected processUpdateTwilioAccount(response: AxiosResponse): Promise<TwilioAccountDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TwilioAccountDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<TwilioAccountDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TwilioAccountDtoApiResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param includeDeleted (optional) 
     * @return OK
     */
    getTwilioAccounts(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, includeDeleted?: boolean | null | undefined, cancelToken?: CancelToken): Promise<TwilioAccountDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/twilio-accounts?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (includeDeleted !== undefined && includeDeleted !== null)
                            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTwilioAccounts(_response);
        });
    }

    protected processGetTwilioAccounts(response: AxiosResponse): Promise<TwilioAccountDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TwilioAccountDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<TwilioAccountDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TwilioAccountDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createTwilioHostedNumberAccount(body?: CreateTwilioHostedNumberDto | undefined, cancelToken?: CancelToken): Promise<CreateTwilioHostedNumberResponseDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/twilio-accounts/hosted";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTwilioHostedNumberAccount(_response);
        });
    }

    protected processCreateTwilioHostedNumberAccount(response: AxiosResponse): Promise<CreateTwilioHostedNumberResponseDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CreateTwilioHostedNumberResponseDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CreateTwilioHostedNumberResponseDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data as string;
            let result409: any = null;
            let resultData409  = JSON.parse(_responseText);
            result409 = ApiResponseDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTwilioHostedNumberResponseDtoApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createTwilioTollFreeAccount(body?: CreateTwilioTollFreeNumberDto | undefined, cancelToken?: CancelToken): Promise<TwilioAccountDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/twilio-accounts/toll-free";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTwilioTollFreeAccount(_response);
        });
    }

    protected processCreateTwilioTollFreeAccount(response: AxiosResponse): Promise<TwilioAccountDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = TwilioAccountDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<TwilioAccountDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data as string;
            let result409: any = null;
            let resultData409  = JSON.parse(_responseText);
            result409 = ApiResponseDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TwilioAccountDtoApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    resendTwilioVerification(accountSid: string, cancelToken?: CancelToken): Promise<ResendVerificationResponseDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/twilio-accounts/{accountSid}/resend-verification";

                    if (accountSid === undefined || accountSid === null)
                throw new Error("The parameter 'accountSid' must be defined.");
                    url_ = url_.replace("{accountSid}", encodeURIComponent("" + accountSid));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendTwilioVerification(_response);
        });
    }

    protected processResendTwilioVerification(response: AxiosResponse): Promise<ResendVerificationResponseDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ResendVerificationResponseDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ResendVerificationResponseDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResendVerificationResponseDtoApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    initializeComplianceInquiry(accountSid: string, cancelToken?: CancelToken): Promise<ComplianceInquirySessionDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/twilio-accounts/{accountSid}/compliance/initialize";

                    if (accountSid === undefined || accountSid === null)
                throw new Error("The parameter 'accountSid' must be defined.");
                    url_ = url_.replace("{accountSid}", encodeURIComponent("" + accountSid));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitializeComplianceInquiry(_response);
        });
    }

    protected processInitializeComplianceInquiry(response: AxiosResponse): Promise<ComplianceInquirySessionDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ComplianceInquirySessionDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ComplianceInquirySessionDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceInquirySessionDtoApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    deleteWebLeadFilter(webLeadFilterId: number, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/integrations/web-lead-filters/{webLeadFilterId}";

                    if (webLeadFilterId === undefined || webLeadFilterId === null)
                throw new Error("The parameter 'webLeadFilterId' must be defined.");
                    url_ = url_.replace("{webLeadFilterId}", encodeURIComponent("" + webLeadFilterId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWebLeadFilter(_response);
        });
    }

    protected processDeleteWebLeadFilter(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getWebLeadFilters(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<WebLeadFilterDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/integrations/web-lead-filters?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebLeadFilters(_response);
        });
    }

    protected processGetWebLeadFilters(response: AxiosResponse): Promise<WebLeadFilterDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = WebLeadFilterDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<WebLeadFilterDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebLeadFilterDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createWebLeadFilter(body?: CreateWebLeadFilterDto | undefined, cancelToken?: CancelToken): Promise<WebLeadFilterDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/integrations/web-lead-filters";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWebLeadFilter(_response);
        });
    }

    protected processCreateWebLeadFilter(response: AxiosResponse): Promise<WebLeadFilterDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = WebLeadFilterDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<WebLeadFilterDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebLeadFilterDtoApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateWebLeadFilter(body?: UpdateWebLeadFilterDto | undefined, cancelToken?: CancelToken): Promise<WebLeadFilterDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/integrations/web-lead-filters";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWebLeadFilter(_response);
        });
    }

    protected processUpdateWebLeadFilter(response: AxiosResponse): Promise<WebLeadFilterDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = WebLeadFilterDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<WebLeadFilterDtoApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebLeadFilterDtoApiResponseDto>(null as any);
    }

    /**
     * @param webLeadFilterId (optional) 
     * @return OK
     */
    getWebLeadFilter(webLeadFilterId?: number | undefined, cancelToken?: CancelToken): Promise<WebLeadFilterDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/integrations/integrations/web-lead-filter?";

                            if (webLeadFilterId === null)
                throw new Error("The parameter 'webLeadFilterId' cannot be null.");
            else if (webLeadFilterId !== undefined)
                            url_ += "webLeadFilterId=" + encodeURIComponent("" + webLeadFilterId) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebLeadFilter(_response);
        });
    }

    protected processGetWebLeadFilter(response: AxiosResponse): Promise<WebLeadFilterDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = WebLeadFilterDtoApiResponseDto.fromJS(resultData200);
            return Promise.resolve<WebLeadFilterDtoApiResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebLeadFilterDtoApiResponseDto>(null as any);
    }
}

export class ApiResponseDto implements IApiResponseDto {
    id!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ApiResponseDto {
        const json = this.toJSON();
        let result = new ApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseDto {
    id: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class ApplicationLogDto implements IApplicationLogDto {
    id?: string | undefined;
    indexName?: string | undefined;
    timestamp!: Date;
    xRequestId?: string | undefined;
    dealerId?: number | undefined;
    dealerName?: string | undefined;
    dealerGroupId?: number | undefined;
    userId?: number | undefined;
    userName?: string | undefined;
    userAgent?: string | undefined;
    device?: string | undefined;
    websiteId?: number | undefined;
    integrationApiId?: number | undefined;
    clientOrigin?: string | undefined;
    requestUrl?: string | undefined;
    requestMethod?: string | undefined;
    requestBody?: string | undefined;
    responseBody?: string | undefined;
    session?: string | undefined;
    level?: string | undefined;
    exception?: string | undefined;
    exceptionMessage?: string | undefined;
    logger?: string | undefined;
    machineName?: string | undefined;
    applicationName?: string | undefined;
    permissions?: string | undefined;
    products?: string | undefined;
    additionalInfo?: string | undefined;
    statusCode?: number | undefined;
    message?: string | undefined;

    constructor(data?: IApplicationLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.indexName = _data["indexName"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.xRequestId = _data["xRequestId"];
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.dealerGroupId = _data["dealerGroupId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userAgent = _data["userAgent"];
            this.device = _data["device"];
            this.websiteId = _data["websiteId"];
            this.integrationApiId = _data["integrationApiId"];
            this.clientOrigin = _data["clientOrigin"];
            this.requestUrl = _data["requestUrl"];
            this.requestMethod = _data["requestMethod"];
            this.requestBody = _data["requestBody"];
            this.responseBody = _data["responseBody"];
            this.session = _data["session"];
            this.level = _data["level"];
            this.exception = _data["exception"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.logger = _data["logger"];
            this.machineName = _data["machineName"];
            this.applicationName = _data["applicationName"];
            this.permissions = _data["permissions"];
            this.products = _data["products"];
            this.additionalInfo = _data["additionalInfo"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApplicationLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["indexName"] = this.indexName;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["xRequestId"] = this.xRequestId;
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["dealerGroupId"] = this.dealerGroupId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userAgent"] = this.userAgent;
        data["device"] = this.device;
        data["websiteId"] = this.websiteId;
        data["integrationApiId"] = this.integrationApiId;
        data["clientOrigin"] = this.clientOrigin;
        data["requestUrl"] = this.requestUrl;
        data["requestMethod"] = this.requestMethod;
        data["requestBody"] = this.requestBody;
        data["responseBody"] = this.responseBody;
        data["session"] = this.session;
        data["level"] = this.level;
        data["exception"] = this.exception;
        data["exceptionMessage"] = this.exceptionMessage;
        data["logger"] = this.logger;
        data["machineName"] = this.machineName;
        data["applicationName"] = this.applicationName;
        data["permissions"] = this.permissions;
        data["products"] = this.products;
        data["additionalInfo"] = this.additionalInfo;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        return data;
    }

    clone(): ApplicationLogDto {
        const json = this.toJSON();
        let result = new ApplicationLogDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationLogDto {
    id?: string | undefined;
    indexName?: string | undefined;
    timestamp: Date;
    xRequestId?: string | undefined;
    dealerId?: number | undefined;
    dealerName?: string | undefined;
    dealerGroupId?: number | undefined;
    userId?: number | undefined;
    userName?: string | undefined;
    userAgent?: string | undefined;
    device?: string | undefined;
    websiteId?: number | undefined;
    integrationApiId?: number | undefined;
    clientOrigin?: string | undefined;
    requestUrl?: string | undefined;
    requestMethod?: string | undefined;
    requestBody?: string | undefined;
    responseBody?: string | undefined;
    session?: string | undefined;
    level?: string | undefined;
    exception?: string | undefined;
    exceptionMessage?: string | undefined;
    logger?: string | undefined;
    machineName?: string | undefined;
    applicationName?: string | undefined;
    permissions?: string | undefined;
    products?: string | undefined;
    additionalInfo?: string | undefined;
    statusCode?: number | undefined;
    message?: string | undefined;
}

export class ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto implements IApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto {
    data!: ApplicationLogDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;
    totals!: ApplicationLogTotalsDto;

    constructor(data?: IApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
            this.totals = new ApplicationLogTotalsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ApplicationLogDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
            this.totals = _data["totals"] ? ApplicationLogTotalsDto.fromJS(_data["totals"]) : new ApplicationLogTotalsDto();
        }
    }

    static fromJS(data: any): ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        return data;
    }

    clone(): ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto {
        const json = this.toJSON();
        let result = new ApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationLogDtoApplicationLogTotalsDtoPagedDataResponseWithTotalsDto {
    data: ApplicationLogDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
    totals: ApplicationLogTotalsDto;
}

export enum ApplicationLogLevelEnum {
    Trace = "Trace",
    Debug = "Debug",
    Info = "Info",
    Warn = "Warn",
    Error = "Error",
    Fatal = "Fatal",
}

export class ApplicationLogTotalsDto implements IApplicationLogTotalsDto {
    applicationNames?: string[] | undefined;

    constructor(data?: IApplicationLogTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicationNames"])) {
                this.applicationNames = [] as any;
                for (let item of _data["applicationNames"])
                    this.applicationNames!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationLogTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLogTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicationNames)) {
            data["applicationNames"] = [];
            for (let item of this.applicationNames)
                data["applicationNames"].push(item);
        }
        return data;
    }

    clone(): ApplicationLogTotalsDto {
        const json = this.toJSON();
        let result = new ApplicationLogTotalsDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationLogTotalsDto {
    applicationNames?: string[] | undefined;
}

export class AudioEyeSiteDto implements IAudioEyeSiteDto {
    id?: string | undefined;
    dealerId!: number;
    dealerName?: string | undefined;
    websiteUrl?: string | undefined;
    status?: string | undefined;
    location?: string | undefined;
    color?: string | undefined;
    toolbarTheme?: string | undefined;
    score!: number;

    constructor(data?: IAudioEyeSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.websiteUrl = _data["websiteUrl"];
            this.status = _data["status"];
            this.location = _data["location"];
            this.color = _data["color"];
            this.toolbarTheme = _data["toolbarTheme"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): AudioEyeSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AudioEyeSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["websiteUrl"] = this.websiteUrl;
        data["status"] = this.status;
        data["location"] = this.location;
        data["color"] = this.color;
        data["toolbarTheme"] = this.toolbarTheme;
        data["score"] = this.score;
        return data;
    }

    clone(): AudioEyeSiteDto {
        const json = this.toJSON();
        let result = new AudioEyeSiteDto();
        result.init(json);
        return result;
    }
}

export interface IAudioEyeSiteDto {
    id?: string | undefined;
    dealerId: number;
    dealerName?: string | undefined;
    websiteUrl?: string | undefined;
    status?: string | undefined;
    location?: string | undefined;
    color?: string | undefined;
    toolbarTheme?: string | undefined;
    score: number;
}

export class AudioEyeSiteDtoApiResponseDto implements IAudioEyeSiteDtoApiResponseDto {
    id!: number;
    payload?: AudioEyeSiteDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IAudioEyeSiteDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? AudioEyeSiteDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): AudioEyeSiteDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AudioEyeSiteDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): AudioEyeSiteDtoApiResponseDto {
        const json = this.toJSON();
        let result = new AudioEyeSiteDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAudioEyeSiteDtoApiResponseDto {
    id: number;
    payload?: AudioEyeSiteDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class AudioEyeSiteDtoPagedDataResponseDto implements IAudioEyeSiteDtoPagedDataResponseDto {
    data!: AudioEyeSiteDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IAudioEyeSiteDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AudioEyeSiteDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): AudioEyeSiteDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AudioEyeSiteDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): AudioEyeSiteDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new AudioEyeSiteDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAudioEyeSiteDtoPagedDataResponseDto {
    data: AudioEyeSiteDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CMSCacheResponse implements ICMSCacheResponse {
    result?: string | undefined;

    constructor(data?: ICMSCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): CMSCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CMSCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data;
    }

    clone(): CMSCacheResponse {
        const json = this.toJSON();
        let result = new CMSCacheResponse();
        result.init(json);
        return result;
    }
}

export interface ICMSCacheResponse {
    result?: string | undefined;
}

export class CMSCacheResponseApiResponseDto implements ICMSCacheResponseApiResponseDto {
    id!: number;
    payload?: CMSCacheResponse | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICMSCacheResponseApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? CMSCacheResponse.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CMSCacheResponseApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CMSCacheResponseApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CMSCacheResponseApiResponseDto {
        const json = this.toJSON();
        let result = new CMSCacheResponseApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICMSCacheResponseApiResponseDto {
    id: number;
    payload?: CMSCacheResponse | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class ComplianceInquirySessionDto implements IComplianceInquirySessionDto {
    inquiryId?: string | undefined;
    sessionToken?: string | undefined;

    constructor(data?: IComplianceInquirySessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inquiryId = _data["inquiryId"];
            this.sessionToken = _data["sessionToken"];
        }
    }

    static fromJS(data: any): ComplianceInquirySessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceInquirySessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inquiryId"] = this.inquiryId;
        data["sessionToken"] = this.sessionToken;
        return data;
    }

    clone(): ComplianceInquirySessionDto {
        const json = this.toJSON();
        let result = new ComplianceInquirySessionDto();
        result.init(json);
        return result;
    }
}

export interface IComplianceInquirySessionDto {
    inquiryId?: string | undefined;
    sessionToken?: string | undefined;
}

export class ComplianceInquirySessionDtoApiResponseDto implements IComplianceInquirySessionDtoApiResponseDto {
    id!: number;
    payload?: ComplianceInquirySessionDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IComplianceInquirySessionDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? ComplianceInquirySessionDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ComplianceInquirySessionDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceInquirySessionDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ComplianceInquirySessionDtoApiResponseDto {
        const json = this.toJSON();
        let result = new ComplianceInquirySessionDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IComplianceInquirySessionDtoApiResponseDto {
    id: number;
    payload?: ComplianceInquirySessionDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CreateAudioEyeSiteDto implements ICreateAudioEyeSiteDto {
    dealerId!: number;
    websiteUrl!: string;
    location!: string;
    color!: string;
    toolbarTheme!: string;

    constructor(data?: ICreateAudioEyeSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.websiteUrl = _data["websiteUrl"];
            this.location = _data["location"];
            this.color = _data["color"];
            this.toolbarTheme = _data["toolbarTheme"];
        }
    }

    static fromJS(data: any): CreateAudioEyeSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAudioEyeSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["websiteUrl"] = this.websiteUrl;
        data["location"] = this.location;
        data["color"] = this.color;
        data["toolbarTheme"] = this.toolbarTheme;
        return data;
    }

    clone(): CreateAudioEyeSiteDto {
        const json = this.toJSON();
        let result = new CreateAudioEyeSiteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAudioEyeSiteDto {
    dealerId: number;
    websiteUrl: string;
    location: string;
    color: string;
    toolbarTheme: string;
}

export class CreateFrazerPayMerchantDto implements ICreateFrazerPayMerchantDto {
    dealerId!: number;
    paymentProcessorMerchantUsername!: string;
    paymentProcessorMerchantPassword!: string;
    paymentProcessorCcMerchantId!: string;

    constructor(data?: ICreateFrazerPayMerchantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.paymentProcessorMerchantUsername = _data["paymentProcessorMerchantUsername"];
            this.paymentProcessorMerchantPassword = _data["paymentProcessorMerchantPassword"];
            this.paymentProcessorCcMerchantId = _data["paymentProcessorCcMerchantId"];
        }
    }

    static fromJS(data: any): CreateFrazerPayMerchantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFrazerPayMerchantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["paymentProcessorMerchantUsername"] = this.paymentProcessorMerchantUsername;
        data["paymentProcessorMerchantPassword"] = this.paymentProcessorMerchantPassword;
        data["paymentProcessorCcMerchantId"] = this.paymentProcessorCcMerchantId;
        return data;
    }

    clone(): CreateFrazerPayMerchantDto {
        const json = this.toJSON();
        let result = new CreateFrazerPayMerchantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFrazerPayMerchantDto {
    dealerId: number;
    paymentProcessorMerchantUsername: string;
    paymentProcessorMerchantPassword: string;
    paymentProcessorCcMerchantId: string;
}

export class CreateKnownIssueDto implements ICreateKnownIssueDto {
    title?: string | undefined;
    description?: string | undefined;
    reportedDate!: Date;
    closeDate?: Date | undefined;
    status?: string | undefined;
    systemArray?: string[] | undefined;
    readonly system?: string | undefined;

    constructor(data?: ICreateKnownIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.reportedDate = _data["reportedDate"] ? new Date(_data["reportedDate"].toString()) : <any>undefined;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["systemArray"])) {
                this.systemArray = [] as any;
                for (let item of _data["systemArray"])
                    this.systemArray!.push(item);
            }
            (<any>this).system = _data["system"];
        }
    }

    static fromJS(data: any): CreateKnownIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKnownIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["reportedDate"] = this.reportedDate ? this.reportedDate.toISOString() : <any>undefined;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.systemArray)) {
            data["systemArray"] = [];
            for (let item of this.systemArray)
                data["systemArray"].push(item);
        }
        data["system"] = this.system;
        return data;
    }

    clone(): CreateKnownIssueDto {
        const json = this.toJSON();
        let result = new CreateKnownIssueDto();
        result.init(json);
        return result;
    }
}

export interface ICreateKnownIssueDto {
    title?: string | undefined;
    description?: string | undefined;
    reportedDate: Date;
    closeDate?: Date | undefined;
    status?: string | undefined;
    systemArray?: string[] | undefined;
    system?: string | undefined;
}

export class CreateTwilioHostedNumberDto implements ICreateTwilioHostedNumberDto {
    dealerId!: number;
    phoneNumber?: string | undefined;
    loaEmail?: string | undefined;
    extension?: string | undefined;
    sendWelcomeMessage!: boolean;
    welcomeMessage?: string | undefined;
    expirationHours?: number | undefined;
    idleMinutes?: number | undefined;

    constructor(data?: ICreateTwilioHostedNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.phoneNumber = _data["phoneNumber"];
            this.loaEmail = _data["loaEmail"];
            this.extension = _data["extension"];
            this.sendWelcomeMessage = _data["sendWelcomeMessage"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.expirationHours = _data["expirationHours"];
            this.idleMinutes = _data["idleMinutes"];
        }
    }

    static fromJS(data: any): CreateTwilioHostedNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTwilioHostedNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["phoneNumber"] = this.phoneNumber;
        data["loaEmail"] = this.loaEmail;
        data["extension"] = this.extension;
        data["sendWelcomeMessage"] = this.sendWelcomeMessage;
        data["welcomeMessage"] = this.welcomeMessage;
        data["expirationHours"] = this.expirationHours;
        data["idleMinutes"] = this.idleMinutes;
        return data;
    }

    clone(): CreateTwilioHostedNumberDto {
        const json = this.toJSON();
        let result = new CreateTwilioHostedNumberDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTwilioHostedNumberDto {
    dealerId: number;
    phoneNumber?: string | undefined;
    loaEmail?: string | undefined;
    extension?: string | undefined;
    sendWelcomeMessage: boolean;
    welcomeMessage?: string | undefined;
    expirationHours?: number | undefined;
    idleMinutes?: number | undefined;
}

export class CreateTwilioHostedNumberResponseDto implements ICreateTwilioHostedNumberResponseDto {
    twilioAccount?: TwilioAccountDto | undefined;
    verificationCode?: string | undefined;

    constructor(data?: ICreateTwilioHostedNumberResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twilioAccount = _data["twilioAccount"] ? TwilioAccountDto.fromJS(_data["twilioAccount"]) : <any>undefined;
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): CreateTwilioHostedNumberResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTwilioHostedNumberResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["twilioAccount"] = this.twilioAccount ? this.twilioAccount.toJSON() : <any>undefined;
        data["verificationCode"] = this.verificationCode;
        return data;
    }

    clone(): CreateTwilioHostedNumberResponseDto {
        const json = this.toJSON();
        let result = new CreateTwilioHostedNumberResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTwilioHostedNumberResponseDto {
    twilioAccount?: TwilioAccountDto | undefined;
    verificationCode?: string | undefined;
}

export class CreateTwilioHostedNumberResponseDtoApiResponseDto implements ICreateTwilioHostedNumberResponseDtoApiResponseDto {
    id!: number;
    payload?: CreateTwilioHostedNumberResponseDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICreateTwilioHostedNumberResponseDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? CreateTwilioHostedNumberResponseDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CreateTwilioHostedNumberResponseDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTwilioHostedNumberResponseDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CreateTwilioHostedNumberResponseDtoApiResponseDto {
        const json = this.toJSON();
        let result = new CreateTwilioHostedNumberResponseDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTwilioHostedNumberResponseDtoApiResponseDto {
    id: number;
    payload?: CreateTwilioHostedNumberResponseDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CreateTwilioTollFreeNumberDto implements ICreateTwilioTollFreeNumberDto {
    dealerId!: number;
    primaryContactFirstName?: string | undefined;
    primaryContactLastName?: string | undefined;
    sendWelcomeMessage!: boolean;
    welcomeMessage?: string | undefined;
    expirationHours?: number | undefined;
    idleMinutes?: number | undefined;

    constructor(data?: ICreateTwilioTollFreeNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.primaryContactFirstName = _data["primaryContactFirstName"];
            this.primaryContactLastName = _data["primaryContactLastName"];
            this.sendWelcomeMessage = _data["sendWelcomeMessage"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.expirationHours = _data["expirationHours"];
            this.idleMinutes = _data["idleMinutes"];
        }
    }

    static fromJS(data: any): CreateTwilioTollFreeNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTwilioTollFreeNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["primaryContactFirstName"] = this.primaryContactFirstName;
        data["primaryContactLastName"] = this.primaryContactLastName;
        data["sendWelcomeMessage"] = this.sendWelcomeMessage;
        data["welcomeMessage"] = this.welcomeMessage;
        data["expirationHours"] = this.expirationHours;
        data["idleMinutes"] = this.idleMinutes;
        return data;
    }

    clone(): CreateTwilioTollFreeNumberDto {
        const json = this.toJSON();
        let result = new CreateTwilioTollFreeNumberDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTwilioTollFreeNumberDto {
    dealerId: number;
    primaryContactFirstName?: string | undefined;
    primaryContactLastName?: string | undefined;
    sendWelcomeMessage: boolean;
    welcomeMessage?: string | undefined;
    expirationHours?: number | undefined;
    idleMinutes?: number | undefined;
}

export class CreateWebLeadFilterDto implements ICreateWebLeadFilterDto {
    dealerId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: ICreateWebLeadFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.email = _data["email"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): CreateWebLeadFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWebLeadFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["ipAddress"] = this.ipAddress;
        return data;
    }

    clone(): CreateWebLeadFilterDto {
        const json = this.toJSON();
        let result = new CreateWebLeadFilterDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWebLeadFilterDto {
    dealerId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    ipAddress?: string | undefined;
}

export enum DeletedStateEnum {
    Undefined = "Undefined",
    Active = "Active",
    Deleted = "Deleted",
    Both = "Both",
}

export class F4SalesEngineSettingsDto implements IF4SalesEngineSettingsDto {
    dontUseCarleton!: boolean;
    f4RequestBodyLoggingEnabled!: boolean;

    constructor(data?: IF4SalesEngineSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dontUseCarleton = _data["dontUseCarleton"];
            this.f4RequestBodyLoggingEnabled = _data["f4RequestBodyLoggingEnabled"];
        }
    }

    static fromJS(data: any): F4SalesEngineSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4SalesEngineSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dontUseCarleton"] = this.dontUseCarleton;
        data["f4RequestBodyLoggingEnabled"] = this.f4RequestBodyLoggingEnabled;
        return data;
    }

    clone(): F4SalesEngineSettingsDto {
        const json = this.toJSON();
        let result = new F4SalesEngineSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IF4SalesEngineSettingsDto {
    dontUseCarleton: boolean;
    f4RequestBodyLoggingEnabled: boolean;
}

export class F4SalesEngineSettingsDtoApiResponseDto implements IF4SalesEngineSettingsDtoApiResponseDto {
    id!: number;
    payload?: F4SalesEngineSettingsDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IF4SalesEngineSettingsDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? F4SalesEngineSettingsDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): F4SalesEngineSettingsDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4SalesEngineSettingsDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): F4SalesEngineSettingsDtoApiResponseDto {
        const json = this.toJSON();
        let result = new F4SalesEngineSettingsDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IF4SalesEngineSettingsDtoApiResponseDto {
    id: number;
    payload?: F4SalesEngineSettingsDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export enum F4SyncQueueResultStatusEnum {
    Undefined = "Undefined",
    Queued = "Queued",
    Processing = "Processing",
    Success = "Success",
    Failed = "Failed",
    NoChange = "NoChange",
    Duplicate = "Duplicate",
    PartialSuccess = "PartialSuccess",
}

export class F4fullSyncDetailDto implements IF4fullSyncDetailDto {
    upsertedCount!: number;
    deletedCount!: number;
    orphanedVehicles?: F4fullSyncVehicleDto[] | undefined;
    upsertFailures?: F4fullSyncVehicleDto[] | undefined;
    deleteFailures?: F4fullSyncVehicleDto[] | undefined;

    constructor(data?: IF4fullSyncDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upsertedCount = _data["upsertedCount"];
            this.deletedCount = _data["deletedCount"];
            if (Array.isArray(_data["orphanedVehicles"])) {
                this.orphanedVehicles = [] as any;
                for (let item of _data["orphanedVehicles"])
                    this.orphanedVehicles!.push(F4fullSyncVehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["upsertFailures"])) {
                this.upsertFailures = [] as any;
                for (let item of _data["upsertFailures"])
                    this.upsertFailures!.push(F4fullSyncVehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteFailures"])) {
                this.deleteFailures = [] as any;
                for (let item of _data["deleteFailures"])
                    this.deleteFailures!.push(F4fullSyncVehicleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): F4fullSyncDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4fullSyncDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upsertedCount"] = this.upsertedCount;
        data["deletedCount"] = this.deletedCount;
        if (Array.isArray(this.orphanedVehicles)) {
            data["orphanedVehicles"] = [];
            for (let item of this.orphanedVehicles)
                data["orphanedVehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.upsertFailures)) {
            data["upsertFailures"] = [];
            for (let item of this.upsertFailures)
                data["upsertFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.deleteFailures)) {
            data["deleteFailures"] = [];
            for (let item of this.deleteFailures)
                data["deleteFailures"].push(item.toJSON());
        }
        return data;
    }

    clone(): F4fullSyncDetailDto {
        const json = this.toJSON();
        let result = new F4fullSyncDetailDto();
        result.init(json);
        return result;
    }
}

export interface IF4fullSyncDetailDto {
    upsertedCount: number;
    deletedCount: number;
    orphanedVehicles?: F4fullSyncVehicleDto[] | undefined;
    upsertFailures?: F4fullSyncVehicleDto[] | undefined;
    deleteFailures?: F4fullSyncVehicleDto[] | undefined;
}

export class F4fullSyncVehicleDto implements IF4fullSyncVehicleDto {
    inventoryId!: number;
    stock?: string | undefined;
    vin?: string | undefined;
    vehicleYear?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    message?: string | undefined;

    constructor(data?: IF4fullSyncVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryId = _data["inventoryId"];
            this.stock = _data["stock"];
            this.vin = _data["vin"];
            this.vehicleYear = _data["vehicleYear"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): F4fullSyncVehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4fullSyncVehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryId"] = this.inventoryId;
        data["stock"] = this.stock;
        data["vin"] = this.vin;
        data["vehicleYear"] = this.vehicleYear;
        data["make"] = this.make;
        data["model"] = this.model;
        data["message"] = this.message;
        return data;
    }

    clone(): F4fullSyncVehicleDto {
        const json = this.toJSON();
        let result = new F4fullSyncVehicleDto();
        result.init(json);
        return result;
    }
}

export interface IF4fullSyncVehicleDto {
    inventoryId: number;
    stock?: string | undefined;
    vin?: string | undefined;
    vehicleYear?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    message?: string | undefined;
}

export class F4syncQueueResultDto implements IF4syncQueueResultDto {
    f4syncQueueResultId!: number;
    dealerId!: number;
    entityTypeName?: string | undefined;
    operationName?: string | undefined;
    refId!: number;
    statusName?: string | undefined;
    statusId!: number;
    message?: string | undefined;
    forceResync!: boolean;
    xRequestId?: string | undefined;
    server?: string | undefined;
    createdDate!: Date;
    hasFullSyncDetail!: boolean;

    constructor(data?: IF4syncQueueResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f4syncQueueResultId = _data["f4syncQueueResultId"];
            this.dealerId = _data["dealerId"];
            this.entityTypeName = _data["entityTypeName"];
            this.operationName = _data["operationName"];
            this.refId = _data["refId"];
            this.statusName = _data["statusName"];
            this.statusId = _data["statusId"];
            this.message = _data["message"];
            this.forceResync = _data["forceResync"];
            this.xRequestId = _data["xRequestId"];
            this.server = _data["server"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.hasFullSyncDetail = _data["hasFullSyncDetail"];
        }
    }

    static fromJS(data: any): F4syncQueueResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4syncQueueResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f4syncQueueResultId"] = this.f4syncQueueResultId;
        data["dealerId"] = this.dealerId;
        data["entityTypeName"] = this.entityTypeName;
        data["operationName"] = this.operationName;
        data["refId"] = this.refId;
        data["statusName"] = this.statusName;
        data["statusId"] = this.statusId;
        data["message"] = this.message;
        data["forceResync"] = this.forceResync;
        data["xRequestId"] = this.xRequestId;
        data["server"] = this.server;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["hasFullSyncDetail"] = this.hasFullSyncDetail;
        return data;
    }

    clone(): F4syncQueueResultDto {
        const json = this.toJSON();
        let result = new F4syncQueueResultDto();
        result.init(json);
        return result;
    }
}

export interface IF4syncQueueResultDto {
    f4syncQueueResultId: number;
    dealerId: number;
    entityTypeName?: string | undefined;
    operationName?: string | undefined;
    refId: number;
    statusName?: string | undefined;
    statusId: number;
    message?: string | undefined;
    forceResync: boolean;
    xRequestId?: string | undefined;
    server?: string | undefined;
    createdDate: Date;
    hasFullSyncDetail: boolean;
}

export class F4syncQueueResultDtoPagedDataResponseDto implements IF4syncQueueResultDtoPagedDataResponseDto {
    data!: F4syncQueueResultDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IF4syncQueueResultDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(F4syncQueueResultDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): F4syncQueueResultDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new F4syncQueueResultDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): F4syncQueueResultDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new F4syncQueueResultDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IF4syncQueueResultDtoPagedDataResponseDto {
    data: F4syncQueueResultDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class FrazerPayMerchant implements IFrazerPayMerchant {
    merchantId!: number;
    dealerId!: number;
    frazerPayMerchantId!: number;
    brandMerchantId?: string | undefined;
    paymentProcessorMerchantUserNameToken?: string | undefined;
    paymentProcessorMerchantPasswordToken?: string | undefined;
    paymentProcessorCcMerchantId?: string | undefined;
    deleted!: boolean;

    constructor(data?: IFrazerPayMerchant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.dealerId = _data["dealerId"];
            this.frazerPayMerchantId = _data["frazerPayMerchantId"];
            this.brandMerchantId = _data["brandMerchantId"];
            this.paymentProcessorMerchantUserNameToken = _data["paymentProcessorMerchantUserNameToken"];
            this.paymentProcessorMerchantPasswordToken = _data["paymentProcessorMerchantPasswordToken"];
            this.paymentProcessorCcMerchantId = _data["paymentProcessorCcMerchantId"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): FrazerPayMerchant {
        data = typeof data === 'object' ? data : {};
        let result = new FrazerPayMerchant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["dealerId"] = this.dealerId;
        data["frazerPayMerchantId"] = this.frazerPayMerchantId;
        data["brandMerchantId"] = this.brandMerchantId;
        data["paymentProcessorMerchantUserNameToken"] = this.paymentProcessorMerchantUserNameToken;
        data["paymentProcessorMerchantPasswordToken"] = this.paymentProcessorMerchantPasswordToken;
        data["paymentProcessorCcMerchantId"] = this.paymentProcessorCcMerchantId;
        data["deleted"] = this.deleted;
        return data;
    }

    clone(): FrazerPayMerchant {
        const json = this.toJSON();
        let result = new FrazerPayMerchant();
        result.init(json);
        return result;
    }
}

export interface IFrazerPayMerchant {
    merchantId: number;
    dealerId: number;
    frazerPayMerchantId: number;
    brandMerchantId?: string | undefined;
    paymentProcessorMerchantUserNameToken?: string | undefined;
    paymentProcessorMerchantPasswordToken?: string | undefined;
    paymentProcessorCcMerchantId?: string | undefined;
    deleted: boolean;
}

export class FrazerPayMerchantApiResponseDto implements IFrazerPayMerchantApiResponseDto {
    id!: number;
    payload?: FrazerPayMerchant | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IFrazerPayMerchantApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? FrazerPayMerchant.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): FrazerPayMerchantApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrazerPayMerchantApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): FrazerPayMerchantApiResponseDto {
        const json = this.toJSON();
        let result = new FrazerPayMerchantApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IFrazerPayMerchantApiResponseDto {
    id: number;
    payload?: FrazerPayMerchant | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class FrazerPayMerchantDto implements IFrazerPayMerchantDto {
    merchantId!: number;
    dealerId!: number;
    dealerName?: string | undefined;
    paymentProcessorCcMerchantId?: string | undefined;
    deleted!: boolean;

    constructor(data?: IFrazerPayMerchantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.paymentProcessorCcMerchantId = _data["paymentProcessorCcMerchantId"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): FrazerPayMerchantDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrazerPayMerchantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["paymentProcessorCcMerchantId"] = this.paymentProcessorCcMerchantId;
        data["deleted"] = this.deleted;
        return data;
    }

    clone(): FrazerPayMerchantDto {
        const json = this.toJSON();
        let result = new FrazerPayMerchantDto();
        result.init(json);
        return result;
    }
}

export interface IFrazerPayMerchantDto {
    merchantId: number;
    dealerId: number;
    dealerName?: string | undefined;
    paymentProcessorCcMerchantId?: string | undefined;
    deleted: boolean;
}

export class FrazerPayMerchantDtoPagedDataResponseDto implements IFrazerPayMerchantDtoPagedDataResponseDto {
    data!: FrazerPayMerchantDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IFrazerPayMerchantDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FrazerPayMerchantDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): FrazerPayMerchantDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrazerPayMerchantDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): FrazerPayMerchantDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new FrazerPayMerchantDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IFrazerPayMerchantDtoPagedDataResponseDto {
    data: FrazerPayMerchantDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class GetCMSCacheObject implements IGetCMSCacheObject {
    environment?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IGetCMSCacheObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environment = _data["environment"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetCMSCacheObject {
        data = typeof data === 'object' ? data : {};
        let result = new GetCMSCacheObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): GetCMSCacheObject {
        const json = this.toJSON();
        let result = new GetCMSCacheObject();
        result.init(json);
        return result;
    }
}

export interface IGetCMSCacheObject {
    environment?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class JenkinsJobBuildsDto implements IJenkinsJobBuildsDto {
    experimentalBuilds?: JenkinsJobInfoDto[] | undefined;
    qaBuilds?: JenkinsJobInfoDto[] | undefined;
    productionBuilds?: JenkinsJobInfoDto[] | undefined;
    queuedBuilds?: JenkinsJobInfoDto[] | undefined;

    constructor(data?: IJenkinsJobBuildsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["experimentalBuilds"])) {
                this.experimentalBuilds = [] as any;
                for (let item of _data["experimentalBuilds"])
                    this.experimentalBuilds!.push(JenkinsJobInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["qaBuilds"])) {
                this.qaBuilds = [] as any;
                for (let item of _data["qaBuilds"])
                    this.qaBuilds!.push(JenkinsJobInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["productionBuilds"])) {
                this.productionBuilds = [] as any;
                for (let item of _data["productionBuilds"])
                    this.productionBuilds!.push(JenkinsJobInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["queuedBuilds"])) {
                this.queuedBuilds = [] as any;
                for (let item of _data["queuedBuilds"])
                    this.queuedBuilds!.push(JenkinsJobInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JenkinsJobBuildsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JenkinsJobBuildsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.experimentalBuilds)) {
            data["experimentalBuilds"] = [];
            for (let item of this.experimentalBuilds)
                data["experimentalBuilds"].push(item.toJSON());
        }
        if (Array.isArray(this.qaBuilds)) {
            data["qaBuilds"] = [];
            for (let item of this.qaBuilds)
                data["qaBuilds"].push(item.toJSON());
        }
        if (Array.isArray(this.productionBuilds)) {
            data["productionBuilds"] = [];
            for (let item of this.productionBuilds)
                data["productionBuilds"].push(item.toJSON());
        }
        if (Array.isArray(this.queuedBuilds)) {
            data["queuedBuilds"] = [];
            for (let item of this.queuedBuilds)
                data["queuedBuilds"].push(item.toJSON());
        }
        return data;
    }

    clone(): JenkinsJobBuildsDto {
        const json = this.toJSON();
        let result = new JenkinsJobBuildsDto();
        result.init(json);
        return result;
    }
}

export interface IJenkinsJobBuildsDto {
    experimentalBuilds?: JenkinsJobInfoDto[] | undefined;
    qaBuilds?: JenkinsJobInfoDto[] | undefined;
    productionBuilds?: JenkinsJobInfoDto[] | undefined;
    queuedBuilds?: JenkinsJobInfoDto[] | undefined;
}

export class JenkinsJobInfoDto implements IJenkinsJobInfoDto {
    buildNumber?: number | undefined;
    timestamp?: Date | undefined;
    app?: string | undefined;
    target?: string | undefined;
    serverType?: string | undefined;
    section?: string | undefined;
    result?: string | undefined;
    jenkinsUrl?: string | undefined;

    constructor(data?: IJenkinsJobInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildNumber = _data["buildNumber"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.app = _data["app"];
            this.target = _data["target"];
            this.serverType = _data["serverType"];
            this.section = _data["section"];
            this.result = _data["result"];
            this.jenkinsUrl = _data["jenkinsUrl"];
        }
    }

    static fromJS(data: any): JenkinsJobInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new JenkinsJobInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildNumber"] = this.buildNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["app"] = this.app;
        data["target"] = this.target;
        data["serverType"] = this.serverType;
        data["section"] = this.section;
        data["result"] = this.result;
        data["jenkinsUrl"] = this.jenkinsUrl;
        return data;
    }

    clone(): JenkinsJobInfoDto {
        const json = this.toJSON();
        let result = new JenkinsJobInfoDto();
        result.init(json);
        return result;
    }
}

export interface IJenkinsJobInfoDto {
    buildNumber?: number | undefined;
    timestamp?: Date | undefined;
    app?: string | undefined;
    target?: string | undefined;
    serverType?: string | undefined;
    section?: string | undefined;
    result?: string | undefined;
    jenkinsUrl?: string | undefined;
}

export class KnownIssueDto implements IKnownIssueDto {
    knownIssueId!: number;
    title?: string | undefined;
    description?: string | undefined;
    reportedDate!: Date;
    closeDate?: Date | undefined;
    status?: string | undefined;
    system?: string | undefined;
    readonly systemArray?: string[] | undefined;
    lastModifiedDate!: Date;

    constructor(data?: IKnownIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knownIssueId = _data["knownIssueId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.reportedDate = _data["reportedDate"] ? new Date(_data["reportedDate"].toString()) : <any>undefined;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.system = _data["system"];
            if (Array.isArray(_data["systemArray"])) {
                (<any>this).systemArray = [] as any;
                for (let item of _data["systemArray"])
                    (<any>this).systemArray!.push(item);
            }
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KnownIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new KnownIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knownIssueId"] = this.knownIssueId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["reportedDate"] = this.reportedDate ? this.reportedDate.toISOString() : <any>undefined;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["system"] = this.system;
        if (Array.isArray(this.systemArray)) {
            data["systemArray"] = [];
            for (let item of this.systemArray)
                data["systemArray"].push(item);
        }
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): KnownIssueDto {
        const json = this.toJSON();
        let result = new KnownIssueDto();
        result.init(json);
        return result;
    }
}

export interface IKnownIssueDto {
    knownIssueId: number;
    title?: string | undefined;
    description?: string | undefined;
    reportedDate: Date;
    closeDate?: Date | undefined;
    status?: string | undefined;
    system?: string | undefined;
    systemArray?: string[] | undefined;
    lastModifiedDate: Date;
}

export class KnownIssueDtoApiResponseDto implements IKnownIssueDtoApiResponseDto {
    id!: number;
    payload?: KnownIssueDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IKnownIssueDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? KnownIssueDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): KnownIssueDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new KnownIssueDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): KnownIssueDtoApiResponseDto {
        const json = this.toJSON();
        let result = new KnownIssueDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IKnownIssueDtoApiResponseDto {
    id: number;
    payload?: KnownIssueDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class KnownIssueDtoPagedDataResponseDto implements IKnownIssueDtoPagedDataResponseDto {
    data!: KnownIssueDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IKnownIssueDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(KnownIssueDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): KnownIssueDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new KnownIssueDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): KnownIssueDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new KnownIssueDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IKnownIssueDtoPagedDataResponseDto {
    data: KnownIssueDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class QueueAllSyncRequestDto implements IQueueAllSyncRequestDto {
    entityType!: SyncEntityTypeEnum;
    forceResync!: boolean;
    deletedState!: DeletedStateEnum;

    constructor(data?: IQueueAllSyncRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.forceResync = _data["forceResync"];
            this.deletedState = _data["deletedState"];
        }
    }

    static fromJS(data: any): QueueAllSyncRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueueAllSyncRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["forceResync"] = this.forceResync;
        data["deletedState"] = this.deletedState;
        return data;
    }

    clone(): QueueAllSyncRequestDto {
        const json = this.toJSON();
        let result = new QueueAllSyncRequestDto();
        result.init(json);
        return result;
    }
}

export interface IQueueAllSyncRequestDto {
    entityType: SyncEntityTypeEnum;
    forceResync: boolean;
    deletedState: DeletedStateEnum;
}

export class ResendVerificationResponseDto implements IResendVerificationResponseDto {
    verificationCode?: string | undefined;

    constructor(data?: IResendVerificationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): ResendVerificationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerificationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationCode"] = this.verificationCode;
        return data;
    }

    clone(): ResendVerificationResponseDto {
        const json = this.toJSON();
        let result = new ResendVerificationResponseDto();
        result.init(json);
        return result;
    }
}

export interface IResendVerificationResponseDto {
    verificationCode?: string | undefined;
}

export class ResendVerificationResponseDtoApiResponseDto implements IResendVerificationResponseDtoApiResponseDto {
    id!: number;
    payload?: ResendVerificationResponseDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IResendVerificationResponseDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? ResendVerificationResponseDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ResendVerificationResponseDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerificationResponseDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ResendVerificationResponseDtoApiResponseDto {
        const json = this.toJSON();
        let result = new ResendVerificationResponseDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IResendVerificationResponseDtoApiResponseDto {
    id: number;
    payload?: ResendVerificationResponseDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export enum SyncEntityTypeEnum {
    Inventory = "Inventory",
    Buyer = "Buyer",
    Vendor = "Vendor",
    AdSource = "AdSource",
    InventoryFullSync = "InventoryFullSync",
}

export enum SyncOperationEnum {
    Upsert = "Upsert",
    Delete = "Delete",
    FullSync = "FullSync",
}

export class SystemInformationDto implements ISystemInformationDto {
    frontendItems?: SystemInformationItemDto[] | undefined;
    backendItems?: SystemInformationItemDto[] | undefined;

    constructor(data?: ISystemInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["frontendItems"])) {
                this.frontendItems = [] as any;
                for (let item of _data["frontendItems"])
                    this.frontendItems!.push(SystemInformationItemDto.fromJS(item));
            }
            if (Array.isArray(_data["backendItems"])) {
                this.backendItems = [] as any;
                for (let item of _data["backendItems"])
                    this.backendItems!.push(SystemInformationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.frontendItems)) {
            data["frontendItems"] = [];
            for (let item of this.frontendItems)
                data["frontendItems"].push(item.toJSON());
        }
        if (Array.isArray(this.backendItems)) {
            data["backendItems"] = [];
            for (let item of this.backendItems)
                data["backendItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): SystemInformationDto {
        const json = this.toJSON();
        let result = new SystemInformationDto();
        result.init(json);
        return result;
    }
}

export interface ISystemInformationDto {
    frontendItems?: SystemInformationItemDto[] | undefined;
    backendItems?: SystemInformationItemDto[] | undefined;
}

export class SystemInformationItemDto implements ISystemInformationItemDto {
    appName?: string | undefined;
    status?: string | undefined;
    machineName?: string | undefined;

    constructor(data?: ISystemInformationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appName = _data["appName"];
            this.status = _data["status"];
            this.machineName = _data["machineName"];
        }
    }

    static fromJS(data: any): SystemInformationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInformationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appName"] = this.appName;
        data["status"] = this.status;
        data["machineName"] = this.machineName;
        return data;
    }

    clone(): SystemInformationItemDto {
        const json = this.toJSON();
        let result = new SystemInformationItemDto();
        result.init(json);
        return result;
    }
}

export interface ISystemInformationItemDto {
    appName?: string | undefined;
    status?: string | undefined;
    machineName?: string | undefined;
}

export class TestDto implements ITestDto {
    prop?: string | undefined;

    constructor(data?: ITestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prop = _data["prop"];
        }
    }

    static fromJS(data: any): TestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prop"] = this.prop;
        return data;
    }

    clone(): TestDto {
        const json = this.toJSON();
        let result = new TestDto();
        result.init(json);
        return result;
    }
}

export interface ITestDto {
    prop?: string | undefined;
}

export class TriggerJenkinsBuildDto implements ITriggerJenkinsBuildDto {
    app!: string;
    section!: string;
    target!: string;
    serverType?: string | undefined;

    constructor(data?: ITriggerJenkinsBuildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.app = _data["app"];
            this.section = _data["section"];
            this.target = _data["target"];
            this.serverType = _data["serverType"];
        }
    }

    static fromJS(data: any): TriggerJenkinsBuildDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerJenkinsBuildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["app"] = this.app;
        data["section"] = this.section;
        data["target"] = this.target;
        data["serverType"] = this.serverType;
        return data;
    }

    clone(): TriggerJenkinsBuildDto {
        const json = this.toJSON();
        let result = new TriggerJenkinsBuildDto();
        result.init(json);
        return result;
    }
}

export interface ITriggerJenkinsBuildDto {
    app: string;
    section: string;
    target: string;
    serverType?: string | undefined;
}

export class TwilioAccountDto implements ITwilioAccountDto {
    accountSid?: string | undefined;
    accountToken?: string | undefined;
    dealerId!: number;
    phoneNumber?: string | undefined;
    sendWelcomeMessage!: boolean;
    welcomeMessage?: string | undefined;
    expirationHours?: number | undefined;
    lac!: boolean;
    pending!: boolean;
    deleted!: boolean;
    idleMinutes?: number | undefined;
    hostedSms?: boolean | undefined;
    hostedNumberOrderSid?: string | undefined;
    twilioStatus?: string | undefined;
    createdDate?: Date | undefined;
    closedDate?: Date | undefined;
    incomingPhoneNumberSid?: string | undefined;
    complianceInquiryId?: string | undefined;
    complianceLastModifiedDate?: Date | undefined;
    dealerName?: string | undefined;

    constructor(data?: ITwilioAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountSid = _data["accountSid"];
            this.accountToken = _data["accountToken"];
            this.dealerId = _data["dealerId"];
            this.phoneNumber = _data["phoneNumber"];
            this.sendWelcomeMessage = _data["sendWelcomeMessage"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.expirationHours = _data["expirationHours"];
            this.lac = _data["lac"];
            this.pending = _data["pending"];
            this.deleted = _data["deleted"];
            this.idleMinutes = _data["idleMinutes"];
            this.hostedSms = _data["hostedSms"];
            this.hostedNumberOrderSid = _data["hostedNumberOrderSid"];
            this.twilioStatus = _data["twilioStatus"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : <any>undefined;
            this.incomingPhoneNumberSid = _data["incomingPhoneNumberSid"];
            this.complianceInquiryId = _data["complianceInquiryId"];
            this.complianceLastModifiedDate = _data["complianceLastModifiedDate"] ? new Date(_data["complianceLastModifiedDate"].toString()) : <any>undefined;
            this.dealerName = _data["dealerName"];
        }
    }

    static fromJS(data: any): TwilioAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountSid"] = this.accountSid;
        data["accountToken"] = this.accountToken;
        data["dealerId"] = this.dealerId;
        data["phoneNumber"] = this.phoneNumber;
        data["sendWelcomeMessage"] = this.sendWelcomeMessage;
        data["welcomeMessage"] = this.welcomeMessage;
        data["expirationHours"] = this.expirationHours;
        data["lac"] = this.lac;
        data["pending"] = this.pending;
        data["deleted"] = this.deleted;
        data["idleMinutes"] = this.idleMinutes;
        data["hostedSms"] = this.hostedSms;
        data["hostedNumberOrderSid"] = this.hostedNumberOrderSid;
        data["twilioStatus"] = this.twilioStatus;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : <any>undefined;
        data["incomingPhoneNumberSid"] = this.incomingPhoneNumberSid;
        data["complianceInquiryId"] = this.complianceInquiryId;
        data["complianceLastModifiedDate"] = this.complianceLastModifiedDate ? this.complianceLastModifiedDate.toISOString() : <any>undefined;
        data["dealerName"] = this.dealerName;
        return data;
    }

    clone(): TwilioAccountDto {
        const json = this.toJSON();
        let result = new TwilioAccountDto();
        result.init(json);
        return result;
    }
}

export interface ITwilioAccountDto {
    accountSid?: string | undefined;
    accountToken?: string | undefined;
    dealerId: number;
    phoneNumber?: string | undefined;
    sendWelcomeMessage: boolean;
    welcomeMessage?: string | undefined;
    expirationHours?: number | undefined;
    lac: boolean;
    pending: boolean;
    deleted: boolean;
    idleMinutes?: number | undefined;
    hostedSms?: boolean | undefined;
    hostedNumberOrderSid?: string | undefined;
    twilioStatus?: string | undefined;
    createdDate?: Date | undefined;
    closedDate?: Date | undefined;
    incomingPhoneNumberSid?: string | undefined;
    complianceInquiryId?: string | undefined;
    complianceLastModifiedDate?: Date | undefined;
    dealerName?: string | undefined;
}

export class TwilioAccountDtoApiResponseDto implements ITwilioAccountDtoApiResponseDto {
    id!: number;
    payload?: TwilioAccountDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ITwilioAccountDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? TwilioAccountDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): TwilioAccountDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioAccountDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): TwilioAccountDtoApiResponseDto {
        const json = this.toJSON();
        let result = new TwilioAccountDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITwilioAccountDtoApiResponseDto {
    id: number;
    payload?: TwilioAccountDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class TwilioAccountDtoPagedDataResponseDto implements ITwilioAccountDtoPagedDataResponseDto {
    data!: TwilioAccountDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ITwilioAccountDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TwilioAccountDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): TwilioAccountDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioAccountDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): TwilioAccountDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new TwilioAccountDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITwilioAccountDtoPagedDataResponseDto {
    data: TwilioAccountDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class UpdateAudioEyeSiteDto implements IUpdateAudioEyeSiteDto {
    dealerId!: number;
    websiteUrl!: string;
    location!: string;
    color!: string;
    toolbarTheme!: string;

    constructor(data?: IUpdateAudioEyeSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.websiteUrl = _data["websiteUrl"];
            this.location = _data["location"];
            this.color = _data["color"];
            this.toolbarTheme = _data["toolbarTheme"];
        }
    }

    static fromJS(data: any): UpdateAudioEyeSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAudioEyeSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["websiteUrl"] = this.websiteUrl;
        data["location"] = this.location;
        data["color"] = this.color;
        data["toolbarTheme"] = this.toolbarTheme;
        return data;
    }

    clone(): UpdateAudioEyeSiteDto {
        const json = this.toJSON();
        let result = new UpdateAudioEyeSiteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAudioEyeSiteDto {
    dealerId: number;
    websiteUrl: string;
    location: string;
    color: string;
    toolbarTheme: string;
}

export class UpdateF4SalesEngineSettingsDto implements IUpdateF4SalesEngineSettingsDto {
    dontUseCarleton!: boolean;
    f4RequestBodyLoggingEnabled!: boolean;

    constructor(data?: IUpdateF4SalesEngineSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dontUseCarleton = _data["dontUseCarleton"];
            this.f4RequestBodyLoggingEnabled = _data["f4RequestBodyLoggingEnabled"];
        }
    }

    static fromJS(data: any): UpdateF4SalesEngineSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateF4SalesEngineSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dontUseCarleton"] = this.dontUseCarleton;
        data["f4RequestBodyLoggingEnabled"] = this.f4RequestBodyLoggingEnabled;
        return data;
    }

    clone(): UpdateF4SalesEngineSettingsDto {
        const json = this.toJSON();
        let result = new UpdateF4SalesEngineSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateF4SalesEngineSettingsDto {
    dontUseCarleton: boolean;
    f4RequestBodyLoggingEnabled: boolean;
}

export class UpdateKnownIssueDto implements IUpdateKnownIssueDto {
    knownIssueId!: number;
    title?: string | undefined;
    description?: string | undefined;
    reportedDate!: Date;
    closeDate?: Date | undefined;
    status?: string | undefined;
    systemArray?: string[] | undefined;
    readonly system?: string | undefined;

    constructor(data?: IUpdateKnownIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knownIssueId = _data["knownIssueId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.reportedDate = _data["reportedDate"] ? new Date(_data["reportedDate"].toString()) : <any>undefined;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["systemArray"])) {
                this.systemArray = [] as any;
                for (let item of _data["systemArray"])
                    this.systemArray!.push(item);
            }
            (<any>this).system = _data["system"];
        }
    }

    static fromJS(data: any): UpdateKnownIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKnownIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knownIssueId"] = this.knownIssueId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["reportedDate"] = this.reportedDate ? this.reportedDate.toISOString() : <any>undefined;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.systemArray)) {
            data["systemArray"] = [];
            for (let item of this.systemArray)
                data["systemArray"].push(item);
        }
        data["system"] = this.system;
        return data;
    }

    clone(): UpdateKnownIssueDto {
        const json = this.toJSON();
        let result = new UpdateKnownIssueDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateKnownIssueDto {
    knownIssueId: number;
    title?: string | undefined;
    description?: string | undefined;
    reportedDate: Date;
    closeDate?: Date | undefined;
    status?: string | undefined;
    systemArray?: string[] | undefined;
    system?: string | undefined;
}

export class UpdateTwilioAccountDto implements IUpdateTwilioAccountDto {
    sendWelcomeMessage!: boolean;
    welcomeMessage?: string | undefined;
    expirationHours?: number | undefined;
    idleMinutes?: number | undefined;
    hostedSms?: boolean | undefined;
    pending!: boolean;

    constructor(data?: IUpdateTwilioAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendWelcomeMessage = _data["sendWelcomeMessage"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.expirationHours = _data["expirationHours"];
            this.idleMinutes = _data["idleMinutes"];
            this.hostedSms = _data["hostedSms"];
            this.pending = _data["pending"];
        }
    }

    static fromJS(data: any): UpdateTwilioAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTwilioAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendWelcomeMessage"] = this.sendWelcomeMessage;
        data["welcomeMessage"] = this.welcomeMessage;
        data["expirationHours"] = this.expirationHours;
        data["idleMinutes"] = this.idleMinutes;
        data["hostedSms"] = this.hostedSms;
        data["pending"] = this.pending;
        return data;
    }

    clone(): UpdateTwilioAccountDto {
        const json = this.toJSON();
        let result = new UpdateTwilioAccountDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTwilioAccountDto {
    sendWelcomeMessage: boolean;
    welcomeMessage?: string | undefined;
    expirationHours?: number | undefined;
    idleMinutes?: number | undefined;
    hostedSms?: boolean | undefined;
    pending: boolean;
}

export class UpdateWebLeadFilterDto implements IUpdateWebLeadFilterDto {
    webLeadFilterId!: number;
    dealerId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IUpdateWebLeadFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webLeadFilterId = _data["webLeadFilterId"];
            this.dealerId = _data["dealerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.email = _data["email"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): UpdateWebLeadFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWebLeadFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webLeadFilterId"] = this.webLeadFilterId;
        data["dealerId"] = this.dealerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["ipAddress"] = this.ipAddress;
        return data;
    }

    clone(): UpdateWebLeadFilterDto {
        const json = this.toJSON();
        let result = new UpdateWebLeadFilterDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWebLeadFilterDto {
    webLeadFilterId: number;
    dealerId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    ipAddress?: string | undefined;
}

export class WebLeadFilterDto implements IWebLeadFilterDto {
    webLeadFilterId!: number;
    dealerId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IWebLeadFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webLeadFilterId = _data["webLeadFilterId"];
            this.dealerId = _data["dealerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.email = _data["email"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): WebLeadFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebLeadFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webLeadFilterId"] = this.webLeadFilterId;
        data["dealerId"] = this.dealerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["ipAddress"] = this.ipAddress;
        return data;
    }

    clone(): WebLeadFilterDto {
        const json = this.toJSON();
        let result = new WebLeadFilterDto();
        result.init(json);
        return result;
    }
}

export interface IWebLeadFilterDto {
    webLeadFilterId: number;
    dealerId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    ipAddress?: string | undefined;
}

export class WebLeadFilterDtoApiResponseDto implements IWebLeadFilterDtoApiResponseDto {
    id!: number;
    payload?: WebLeadFilterDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IWebLeadFilterDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? WebLeadFilterDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): WebLeadFilterDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebLeadFilterDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): WebLeadFilterDtoApiResponseDto {
        const json = this.toJSON();
        let result = new WebLeadFilterDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IWebLeadFilterDtoApiResponseDto {
    id: number;
    payload?: WebLeadFilterDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class WebLeadFilterDtoPagedDataResponseDto implements IWebLeadFilterDtoPagedDataResponseDto {
    data!: WebLeadFilterDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IWebLeadFilterDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WebLeadFilterDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): WebLeadFilterDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebLeadFilterDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): WebLeadFilterDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new WebLeadFilterDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IWebLeadFilterDtoPagedDataResponseDto {
    data: WebLeadFilterDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class V1ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isV1ApiException = true;

    static isV1ApiException(obj: any): obj is V1ApiException {
        return obj.isV1ApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new V1ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}